/**
 * LOT M1 (2026-11-04) — cadrage PAR DÉFAUT de la carte de l'atlas.
 *
 * Sur un téléphone, le cadre « local » (centré sur le prochain show, rayon
 * `LOCAL_RADIUS_KM`) ne contient QUE ce show : dans une carte de 390×260 on ne
 * voit qu'une cible isolée, aucune route — d'où le retour « le titre ROUTE MAP
 * est trompeur, il n'y a pas de carte ». Sur écran étroit le défaut est donc
 * « toutes les dates » ; le bureau garde le cadrage local, inchangé.
 *
 * Cette décision est extraite ici (fonction pure) pour être TESTABLE sans
 * monter la page entière ni simuler `matchMedia`. Ce n'est qu'une valeur de
 * DÉPART : les boutons de la carte restent maîtres et rien n'est persisté.
 */
export type AtlasMode = 'local' | 'all';

export function atlasDefaultMode(isNarrowScreen: boolean): AtlasMode {
  return isNarrowScreen ? 'all' : 'local';
}
